import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
    const { token, setToken } = useAuth();

    const handleLogout = () => {
        setToken(null); 
    };

    return (
        <header>
            <nav>
                <Link to="/" className="logo">ECPay Demo</Link>
                <ul>
                    <li><Link to="/subscriptions">訂閱管理</Link></li>
                    <li><Link to="/redeem">兌換方案</Link></li>
                    <li><Link to="/bind-card">綁定信用卡</Link></li>
                    <li><Link to="/manage-cards">信用卡管理</Link></li>
                    <li><Link to="/mkpu">MKPU管理</Link></li>
                    <li><Link to="/payment-history">交易紀錄</Link></li>
                    <li><Link to="/dev-tools">開發工具</Link></li>
                    <li><Link to="/admin">管理員</Link></li>
                    {token && (
                         <li><button onClick={handleLogout} className="logout-button">登出</button></li>
                    )}
                </ul>
            </nav>
        </header>
    );
};

export default Header;